import type { MatchSessionResult, MatchSessionState } from "./types";

/**
 * Generic achievement rules for any match-learning game.
 * Game-specific achievements live in Layer 4 (code/managers/AchievementManager.ts).
 */
export interface GenericAchievement {
  id: string;
  displayName: string;
  check: (state: MatchSessionState, result?: MatchSessionResult) => boolean;
}

export const GENERIC_ACHIEVEMENTS: GenericAchievement[] = [
  {
    id: "streak_5",
    displayName: "5 in a row",
    check: (state) => state.bestStreak >= 5
  },
  {
    id: "streak_10",
    displayName: "10 in a row",
    check: (state) => state.bestStreak >= 10
  },
  {
    id: "session_perfect",
    displayName: "Perfect session",
    check: (state, result) =>
      result !== undefined && result.wrongCount === 0 && result.correctCount > 0
  }
];
